/**
 * Load script asynchronously
 * @param {String} url Resource URL to load
 * @param {Object} attr Attributes to append to the script element
 * @returns {Promise}
 */
function loadScript(url, attr = {}) {
  return new Promise((resolve, reject) => {
    const scr = document.createElement('script');
    scr.src = url;
    scr.onload = resolve;
    scr.onerror = reject;
    Object.keys(attr).forEach((name) => scr.setAttribute(name, attr[name]));
    document.head.appendChild(scr);
  });
}
export default loadScript;
